var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"admin-company-create"},[_c('AHeading',{staticClass:"admin-company-create__heading",attrs:{"level":1}},[_vm._v("法人追加")]),_c('OCompanyCreateCsv')],1)}
var staticRenderFns = []

export { render, staticRenderFns }